import React from 'react';
import { Scan, Activity, Palette, Zap, Award, MapPin } from 'lucide-react';
import { technologies } from '../mock';

const iconMap = {
  Scan: Scan,
  Activity: Activity,
  Palette: Palette,
  Zap: Zap,
  Award: Award,
  MapPin: MapPin
};

const Technology = () => {
  return (
    <section id="technology" className="py-24 bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900 text-white relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-amber-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold">
            <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Advanced Technology</span>
            <span className="block mt-2">That Changes Lives</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Our innovative approach combines cutting-edge 3D printing, smart sensing, and user-centric design to deliver Hyper-Customized and comfortable Prosthetic & Orthotic Accessories.
          </p>
        </div>

        {/* Technology Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {technologies.map((tech, index) => {
            const IconComponent = iconMap[tech.icon];
            return (
              <div
                key={tech.id}
                className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="bg-gradient-to-br from-purple-500 to-blue-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-3">{tech.title}</h3>
                <p className="text-gray-300">{tech.description}</p>
              </div>
            );
          })}
        </div>

        {/* Bottom Image Section */}
        <div className="mt-20 grid md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl md:text-4xl font-bold">
              Precision Manufacturing
              <span className="block bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
                Local Production
              </span>
            </h3>
            <p className="text-lg text-gray-300 leading-relaxed">
              Our decentralized 3D printing labs bring manufacturing closer to patients, reducing costs, delivery times, and ensuring personalized care at every step.
            </p>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-purple-400 rounded-full"></div>
                <span className="text-gray-300">Industry-leading 3D printing technology</span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-gray-300">Medical-grade materials certification</span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                <span className="text-gray-300">Quality assurance at every stage</span>
              </li>
            </ul>
          </div>
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_access-limbs/artifacts/9p9yo841_Gemini_Generated_Image_o6xuqao6xuqao6xu.png"
                alt="3D Printing Technology"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-purple-400 to-blue-400 rounded-full opacity-30 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;